import { Icon } from '@talend/design-system';

Icon.displayName = 'Icon';

export default Icon;
